import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {WorkoutPickerModal} from '../pages/comparison/WorkoutPickerModal';
import type {WorkoutSummary} from '../pages/comparison/types';
import {StravaExportButton} from './StravaExportButton';
import {NmButton} from './NmButton';

export function StravaConnectionExports({userId}: {userId: number}) {
  const {t} = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<WorkoutSummary | null>(null);
  return <section style={{padding: 16}} aria-label="Strava">
    <p><strong>Strava</strong></p>
    <NmButton onClick={() => setOpen(true)}>{t('stravaExport.choose')}</NmButton>
    {selected && <div>
      <p>{selected.title} · {selected.workout_day}</p>
      <StravaExportButton key={selected.id} workoutId={selected.id} />
    </div>}
    {open && <WorkoutPickerModal open athleteUserId={userId} slotLabel="Strava"
      onClose={() => setOpen(false)} onSelect={workout => {
        if (workout.userId === userId && Number(workout.total_time) > 0) setSelected(workout);
        setOpen(false);
      }} />}
  </section>;
}
